import * as React from "react";
import {cx} from "emotion";

import "./money-input-2.scss";

import {cs}                 from "@Common/react/chain-services";
import {NumberInputBinding} from "@Common/react/number-input-binding";
import {UseState}           from "@Common/react/use-state";

export const MoneyInput2 = ({state, className=undefined, style=undefined, ...params}) => cs(
    ["focused", (_, next) => UseState({next})],
    ["binding", (_, next) => NumberInputBinding({state, next})],
    ({focused, binding}) => (
        <div className={cx("money-input money-input-8fj", {focused: focused.value})}>
            <input {...{
                ...params,
                className: cx(className),
                style: {
                    ...style?.height && {
                        height: style.height,
                    },
                },
                ...!focused.value ? {
                    value: state.value == null ? "" : (Math.round(state.value*100)/100).toLocaleString("en-US", {minimumFractionDigits: 2, maximumFractionDigits: 2}),
                    onChange: () => {},
                } : (
                    binding
                ),
                onFocus: (e) => {
                    focused.onChange(true);
                    e.target.select();
                },
                onBlur: () => {
                    focused.onChange(false);
                    binding.onBlur();
                },
            }}
                xd-qa-type="textbox"
                xd-qa-name="Amount"
            />

            <div className="dollar-sign">
                $
            </div>
        </div>
    )
);
